export default [
    {
        name: '__slot:zen_report_concurrent_title',
        sortField: 'name',
        type: 'string',
        useInFilter: true,
        defaultSearch: true
    },
    {
        name: 'viewsTillEndRank',
        sortField: 'viewsTillEndRank',
        type: 'number',
        useInFilter: true,
        callback: 'number',
    },
    {
        name: 'countPosts',
        sortField: 'countPosts',
        type: 'number',
        useInFilter: true,
        dataClass: 'ral',
        callback: 'number',
    },
    {
        name: 'views',
        sortField: 'views',
        type: 'number',
        useInFilter: true,
        dataClass: 'ral',
        callback: 'number',
    },
    {
        name: 'viewsTillEnd',
        sortField: 'viewsTillEnd',
        type: 'number',
        useInFilter: true,
        dataClass: 'ral',
        callback: 'number',
    },
    {
        name: 'auditory',
        sortField: 'auditory',
        type: 'number',
        useInFilter: true,
        dataClass: 'ral',
        callback: 'number',
    },
    {
        name: 'subscribers',
        sortField: 'subscribers',
        type: 'number',
        useInFilter: true,
        dataClass: 'ral',
        callback: 'number',
    },
]
